import HasParentList from "./HasParentList";

export default HasParentList